import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const GreetingRoot = styled(Flex)`
    flex-shrink: 0;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const HeadlineParagraph = styled.p`
    margin: 0;
    padding: 0;
`;

export const BodyText = styled(Text)`
    && {
        line-height: 24px;
    }

    white-space: pre-line;
`;

export const FirstNameAccent = styled.span`
    margin-inline-start: 4px;
    ${setFontVariant("subtitle1", colorsPalettes.blue[400])};
`;
